import React, { useState, useEffect, useRef, useMemo } from "react";
import { Link } from 'react-router-dom';
import { Col, Row, Card, Container, Breadcrumb, Badge, Table, ProgressBar } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import CustomToast from '../../components/CustomToast';
import { Button } from 'primereact/button';
import axios from 'axios';
import config from '../../config';
import { useClientAuth } from '../../context/ClientAuthContext';
import GifLoder from '../../components/GifLoder';
import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Calendar } from "primereact/calendar";
import { Dropdown } from "primereact/dropdown";
import { InputTextarea } from 'primereact/inputtextarea';

import { GiCheckMark } from "react-icons/gi";
import OnboardingTour from '../../components/onboarding/OnboardingTour';
import clientOnboardingFormSteps from '../../components/onboarding/clientOnboardingFormSteps';
import { ONBOARDING_CHAIN_PHASE, handleOnboardingChainFinish } from '../../components/onboarding/onboardingStorage';
const Onboarding_Form = () => {
    const { role, username, ClientId, apiRequest } = useClientAuth();
    const navigate = useNavigate();
    const { type } = useParams();
    const toastRef = useRef(null);
    const [forms, setForms] = useState([]);
    const [selectedForm, setSelectedForm] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [formData, setFormData] = useState({});
    const [currentStep, setCurrentStep] = useState(0);
    const [duplicatedSections, setDuplicatedSections] = useState({});
    const [invalidFields, setInvalidFields] = useState({});
    const fieldRefs = useRef({});
    const showMessage = (severity, detail) => {
        const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
        toastRef.current.show(severity, summary, detail);
    };

    const fieldKey = (ownerId, fieldId) => `${ownerId}__${fieldId}`;

    const [transition, setTransition] = useState(''); // Manage transition state

    const handleNavigation = (path, animationClass) => {
        setTransition(animationClass); // Set the animation class
        setTimeout(() => {
            navigate(path); // Navigate after animation
            setTransition(''); // Reset transition state
        }, 800); // Match the animation duration
    };







    // Fetch Forms by Category
    const fetchForms = async (type) => {
        setLoading(true);
        try {
            const response = await apiRequest(
                `${config.apiBASEURL}/ClientFormRoutes/fetch-forms-for-clients?type=${type}`
            );
            setForms(response.data);

            // Automatically select the first form if available
            if (response.data.length > 0) {
                setSelectedForm(response.data[0]);
            } else {
                setSelectedForm(null);
            }
        } catch (err) {

            console.error("Error fetching forms:", err);
            setSelectedForm(null);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchForms(type);
    }, [type]);



    const handleChange = (sectionId, fieldId, value, isDuplicate = false, duplicateId = null) => {
        const key = fieldKey(isDuplicate && duplicateId ? duplicateId : sectionId, fieldId);
        if (invalidFields[key] && value !== undefined && value !== null && value !== "") {
            setInvalidFields((prev) => {
                if (!prev[key]) return prev;
                const updated = { ...prev };
                delete updated[key];
                return updated;
            });
        }

        if (isDuplicate && duplicateId) {
            setFormData((prev) => ({
                ...prev,
                [duplicateId]: {
                    ...prev[duplicateId],
                    [fieldId]: value
                }
            }));
        } else {
            setFormData((prev) => ({
                ...prev,
                [sectionId]: {
                    ...prev[sectionId],
                    [fieldId]: value
                }
            }));
        }
    };


    /*-------------------Steep_count------------------*/

    // Sections grouped by their step, ordered the same way as the sidebar/body render them
    const groupedStepEntries = useMemo(() => {
        if (!selectedForm?.sections) return [];
        const grouped = selectedForm.sections.reduce((acc, section) => {
            acc[section.step] = acc[section.step] || [];
            acc[section.step].push(section);
            return acc;
        }, {});
        return Object.entries(grouped).sort(([stepA], [stepB]) => stepA - stepB);
    }, [selectedForm]);

    const totalSteps = groupedStepEntries.length;

    const progressPercentage = ((currentStep + 1) / totalSteps) * 100;

    // Validates every required field belonging to the given step index (normal + duplicated sections)
    const validateStep = (stepIndex) => {
        const sections = groupedStepEntries[stepIndex]?.[1] || [];
        const newInvalid = {};
        let firstInvalidKey = null;

        const markIfMissing = (ownerId, field, responseValue) => {
            if (field.is_required && (responseValue === undefined || responseValue === null || responseValue === "")) {
                const key = fieldKey(ownerId, field.form_fields_id ?? field.id);
                newInvalid[key] = true;
                if (!firstInvalidKey) firstInvalidKey = key;
            }
        };

        sections.forEach((section) => {
            section.fields.forEach((field) => {
                const responseValue = formData?.[section.form_section_id]?.[field.form_fields_id];
                markIfMissing(section.form_section_id, field, responseValue);
            });

            if (duplicatedSections[section.form_section_id]) {
                duplicatedSections[section.form_section_id].forEach((dup) => {
                    dup.fields.forEach((field) => {
                        const responseValue = formData?.[dup.id]?.[field.id];
                        markIfMissing(dup.id, field, responseValue);
                    });
                });
            }
        });

        return { isValid: Object.keys(newInvalid).length === 0, invalidMap: newInvalid, firstInvalidKey };
    };

    const nextStep = () => {
        const { isValid, invalidMap, firstInvalidKey } = validateStep(currentStep);

        if (!isValid) {
            setInvalidFields(invalidMap);
            showMessage("error", "Please fill in all required fields before proceeding to the next step.");

            const firstInvalidEl = firstInvalidKey && fieldRefs.current[firstInvalidKey];
            if (firstInvalidEl) {
                firstInvalidEl.scrollIntoView({ behavior: "smooth", block: "center" });
            }
            return;
        }

        setInvalidFields({});
        setCurrentStep((prev) => Math.min(prev + 1, totalSteps - 1));
    };

    const prevStep = () => {
        // Going back is always allowed; drop stale highlighting from the step we're leaving
        setInvalidFields({});
        setCurrentStep((prev) => Math.max(prev - 1, 0));
    };

    const duplicateSection = (section) => {
        setDuplicatedSections((prev) => {
            const duplicateId = `dup-${Date.now()}`; // Unique ID for each duplicate

            // Deep copy the section and its fields, ensuring unique field IDs
            const newDuplicate = {
                id: duplicateId,
                section_name: section.section_name,
                step: section.step,
                fields: section.fields.map(field => ({
                    ...field,
                    id: `${duplicateId}-${field.form_fields_id}`, // Unique field ID per duplicate
                }))
            };

            return {
                ...prev,
                [section.form_section_id]: [...(prev[section.form_section_id] || []), newDuplicate],
            };
        });
    };



    const removeDuplicatedSection = (sectionId, duplicateId) => {
        setDuplicatedSections((prev) => ({
            ...prev,
            [sectionId]: prev[sectionId].filter((dup) => dup.id !== duplicateId),
        }));
    };



    const handleSubmit = async () => {
        if (!selectedForm) return;

        const submissionData = {
            form_name: selectedForm.form_name,
            type: type,
            submission_date: new Date().toISOString(),
            Client_id: ClientId,
            responses: [],
        };

        let hasMissingData = false;

        // Normal sections
        selectedForm.sections.forEach((section) => {
            section.fields.forEach((field) => {
                let responseValue = formData?.[section.form_section_id]?.[field.form_fields_id] || "";

                if (field.is_required && !responseValue) {
                    hasMissingData = true; // Mark missing required fields
                } else if (!field.is_required && !responseValue) {
                    responseValue = "N/A"; // Auto-fill non-required fields with "N/A"
                }

                submissionData.responses.push({
                    section_name: section.section_name,
                    step: section.step,
                    field_label: field.field_label,
                    input_type: field.input_type,
                    response: responseValue,
                });
            });

            // Process duplicated sections
            if (duplicatedSections[section.form_section_id]) {
                duplicatedSections[section.form_section_id].forEach((dup, index) => {
                    const sectionNumber = index + 2; // Start at 2 and increment

                    dup.fields.forEach((field) => {
                        let responseValue = formData?.[dup.id]?.[field.id] || "";

                        if (field.is_required && !responseValue) {
                            hasMissingData = true;
                        } else if (!field.is_required && !responseValue) {
                            responseValue = "N/A";
                        }

                        submissionData.responses.push({
                            section_name: `${section.section_name} ${sectionNumber}`, // Numbered name
                            step: section.step,
                            field_label: field.field_label,
                            input_type: field.input_type,
                            response: responseValue,
                        });
                    });
                });
            }
        });

        // Prevent submission if any required field is missing
        if (hasMissingData) {
            showMessage("error", "Please fill in all required fields before submitting.");
            return;
        }


        try {
            const response = await apiRequest(`${config.apiBASEURL}/ClientFormRoutes/submit-form`, {
                method: "POST",
                data: submissionData,
            });

            if (response.status === 201) {
                showMessage("success", "Form submitted successfully!");
                navigate("/Client/dashboard/Client_home", { replace: true });
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            showMessage("error", "Failed to submit form. Please try again.");
        }
    };




    if (loading) {
        return <div className="loderDiv">
            <GifLoder />
        </div>;
    }





    return (
        <>
            <OnboardingTour
                steps={clientOnboardingFormSteps}
                namespace="client-onboarding-form"
                onFinish={(status) => {
                    const nextPath = handleOnboardingChainFinish(ONBOARDING_CHAIN_PHASE.FORM, status);
                    if (nextPath) navigate(nextPath);
                }}
            />
            <Container className="pt-5">
                <Row className="pt-5 mb-3">
                    <Breadcrumb>
                        <Breadcrumb.Item onClick={() => handleNavigation('/Client/dashboard/Client_home', 'slide-right')}><i className="pi pi-angle-left"></i> Back</Breadcrumb.Item>
                        <Breadcrumb.Item active>{type} Form</Breadcrumb.Item>
                    </Breadcrumb>
                </Row>
                <Row className="mx-0 justify-content-center pt-3 serviceCol serviceclient">

                    <Col lg={3} className="">
                        <Card className="sticky-top h-auto shadow-sm" data-onboarding="client-onboarding-form-list">
                            {forms.length > 0 ? (
                                forms.map((form) => (
                                    <div
                                        key={form.form_id}
                                        className={`rounded-lg p-2 clickable 
                            ${selectedForm?.form_id === form.form_id ? "text-white activebgcolor" : "bg-white text-dark inactivebgcolor"}`}
                                        onClick={() => {
                                            setSelectedForm(form);
                                            setCurrentStep(0);
                                            setInvalidFields({});
                                        }}
                                        style={{ cursor: 'pointer' }}
                                    >

                                        <div className="d-flex justify-content-between align-items-center p-3" style={{ border: '1px dashed #14a8b6', borderRadius: '6px' }}>
                                            <h6 className="mb-0 text-black">
                                                {form.form_name}
                                                <small className="text-muted mb-0 mt-1 d-block" style={{ fontWeight: '400' }}>
                                                    {form.description}
                                                </small>
                                            </h6>

                                        </div>

                                    </div>
                                ))
                            ) : (
                                <p className="p-4">No forms available for this category.</p>
                            )}
                        </Card>
                    </Col>
                    <Col lg={9} className="">
                        {selectedForm ? (
                            <Card className="mt-6 shadow-0 border">
                                <Card.Header>
                                    <div data-onboarding="client-onboarding-form-header">
                                        <h6 className="mb-0">{selectedForm.form_name}</h6>
                                        <p className="mb-0 text-muted"><small>{selectedForm.description}</small></p>
                                    </div>
                                    <div className="d-flex justify-content-left pt-4 pb-5 w-100" data-onboarding="client-onboarding-form-progress">
                                        <div className="w-100 position-relative">
                                            <ProgressBar now={progressPercentage} variant="success" />
                                            <div className="d-flex justify-content-between position-absolute w-100" style={{ top: "-10px" }}>
                                                {Array.from({ length: totalSteps }, (_, index) => (
                                                    <div key={index} className="position-relative text-center">
                                                        <div
                                                            className={`rounded-circle d-flex align-items-center justify-content-center 
                                                                        ${index <= currentStep ? "bg-success text-white" : "bg-light border"}
                                                                    `}
                                                            style={{ width: "24px", height: "24px" }}
                                                        >
                                                            {index <= currentStep && <GiCheckMark size={16} />}
                                                        </div>
                                                        <div className="mt-2" style={{ fontSize: "14px" }}>Step {index + 1}</div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </Card.Header>

                                <Card.Body data-onboarding="client-onboarding-form-fields">
                                    {/* Group sections by step */}
                                    {groupedStepEntries
                                        .map(([step, sections], index) =>
                                            currentStep === index ? (
                                                <div key={step} >
                                                    {sections.map((section, sectionIndex) => (
                                                        <div key={section.form_section_id} className="mb-4" >
                                                            <div className="d-flex justify-content-between align-items-center">
                                                                <h6>{section.section_name}</h6>
                                                                {section.is_repeatable && (
                                                                    <Button
                                                                        label="Add"
                                                                        icon="pi pi-plus"
                                                                        className="p-0"
                                                                        text
                                                                        severity="danger"
                                                                        onClick={() => duplicateSection(section)}
                                                                    />
                                                                )}
                                                            </div>

                                                            <div className="mt-2 d-flex flex-wrap gap-2 justify-content-between">
                                                                {section.fields.map((field, fieldIndex) => {
                                                                    const isInvalid = !!invalidFields[fieldKey(section.form_section_id, field.form_fields_id)];
                                                                    // The very first question of the currently visible wizard step - used to
                                                                    // anchor the two "here's how a question works" tour steps (see
                                                                    // clientOnboardingFormSteps.js) onto a real, always-present field instead
                                                                    // of a specific one that may not exist on every form.
                                                                    const isFirstQuestion = sectionIndex === 0 && fieldIndex === 0;
                                                                    return (
                                                                    <div
                                                                        key={field.form_fields_id}
                                                                        className="mt-2 respwidth"
                                                                        style={{ width: '48.5%' }}
                                                                        ref={(el) => (fieldRefs.current[fieldKey(section.form_section_id, field.form_fields_id)] = el)}
                                                                    >
                                                                        <label
                                                                            className="block font-medium mb-2"
                                                                            data-onboarding={isFirstQuestion ? 'client-onboarding-form-first-question' : undefined}
                                                                        >
                                                                            {field.field_label} {field.is_required && <sup className="text-danger">*</sup>}
                                                                        </label>

                                                                        <div data-onboarding={isFirstQuestion ? 'client-onboarding-form-first-answer' : undefined}>
                                                                            {field.input_type === "text" && (
                                                                                <InputText
                                                                                    value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                    onChange={(e) =>
                                                                                        handleChange(section.form_section_id, field.form_fields_id, e.target.value)
                                                                                    }
                                                                                    className={`w-full p-2 ${isInvalid ? "p-invalid" : ""}`}
                                                                                    required={field.is_required}
                                                                                />
                                                                            )}

                                                                            {field.input_type === "number" && (
                                                                                <InputNumber
                                                                                    value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                    onValueChange={(e) =>
                                                                                        handleChange(section.form_section_id, field.form_fields_id, e.value)
                                                                                    }
                                                                                    className={`w-full ${isInvalid ? "p-invalid" : ""}`}
                                                                                    required={field.is_required}
                                                                                />
                                                                            )}

                                                                            {field.input_type === "email" && (
                                                                                <InputText
                                                                                    type="email"
                                                                                    value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                    onChange={(e) =>
                                                                                        handleChange(section.form_section_id, field.form_fields_id, e.target.value)
                                                                                    }
                                                                                    className={`w-full p-2 ${isInvalid ? "p-invalid" : ""}`}
                                                                                    required={field.is_required}
                                                                                />
                                                                            )}

                                                                            {field.input_type === "date" && (
                                                                                <Calendar
                                                                                    value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                    onChange={(e) =>
                                                                                        handleChange(section.form_section_id, field.form_fields_id, e.value)
                                                                                    }
                                                                                    className={`w-full ${isInvalid ? "p-invalid" : ""}`}
                                                                                    required={field.is_required}
                                                                                />
                                                                            )}

                                                                            {field.input_type === "textarea" && (
                                                                                <InputTextarea
                                                                                    value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                    onChange={(e) =>
                                                                                        handleChange(section.form_section_id, field.form_fields_id, e.target.value)
                                                                                    }
                                                                                    rows={4}
                                                                                    className={`w-full p-2 h-auto ${isInvalid ? "p-invalid" : ""}`}
                                                                                    required={field.is_required}
                                                                                />
                                                                            )}

                                                                            {field.input_type === "select" && field.options && (
                                                                                <Dropdown
                                                                                    value={formData?.[section.form_section_id]?.[field.form_fields_id] || ""}
                                                                                    options={field.options.split(",").map((option) => ({
                                                                                        label: option.trim(),
                                                                                        value: option.trim(),
                                                                                    }))}
                                                                                    onChange={(e) =>
                                                                                        handleChange(section.form_section_id, field.form_fields_id, e.value)
                                                                                    }
                                                                                    placeholder="Select an option"
                                                                                    className={`w-full ${isInvalid ? "p-invalid" : ""}`}
                                                                                    required={field.is_required}
                                                                                />
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    );
                                                                })}
                                                            </div>

                                                            {/* Display Duplicated Sections */}
                                                            {section.is_repeatable && duplicatedSections[section.form_section_id]?.length > 0 &&
                                                                duplicatedSections[section.form_section_id].map((dup, i) => (
                                                                    <div key={dup.id} className="mt-3 oddSteplist d-flex flex-wrap gap-2 justify-content-between">
                                                                        <div className="d-flex justify-content-between align-items-center pb-2 mb-3" style={{ width: '100%' }}>
                                                                            <h6>{section.section_name} {i + 2}</h6>
                                                                            <Button
                                                                                title="Remove"
                                                                                icon="pi pi-trash"
                                                                                className="p-0"
                                                                                text
                                                                                severity="danger"
                                                                                onClick={() => removeDuplicatedSection(section.form_section_id, dup.id)}
                                                                            />
                                                                        </div>

                                                                        {dup.fields.map((field) => {
                                                                            const isInvalid = !!invalidFields[fieldKey(dup.id, field.id)];
                                                                            return (
                                                                            <div
                                                                                key={field.id}
                                                                                className="mt-2"
                                                                                style={{ width: '48.5%' }}
                                                                                ref={(el) => (fieldRefs.current[fieldKey(dup.id, field.id)] = el)}
                                                                            >
                                                                                <label className="d-block mb-2">{field.field_label} {field.is_required && <sup className="text-danger">*</sup>}</label>

                                                                                {field.input_type === "text" && (
                                                                                    <InputText
                                                                                        value={formData?.[dup.id]?.[field.id] || ""}
                                                                                        onChange={(e) =>
                                                                                            handleChange(section.form_section_id, field.id, e.target.value, true, dup.id)
                                                                                        }
                                                                                        className={`w-full p-2 bg-gray-200 ${isInvalid ? "p-invalid" : ""}`}
                                                                                        required={field.is_required}
                                                                                    />
                                                                                )}

                                                                                {field.input_type === "number" && (
                                                                                    <InputNumber
                                                                                        value={formData?.[dup.id]?.[field.id] || ""}
                                                                                        onValueChange={(e) =>
                                                                                            handleChange(section.form_section_id, field.id, e.value, true, dup.id)
                                                                                        }
                                                                                        className={`w-full bg-gray-200 ${isInvalid ? "p-invalid" : ""}`}
                                                                                        required={field.is_required}
                                                                                    />
                                                                                )}

                                                                                {field.input_type === "email" && (
                                                                                    <InputText
                                                                                        type="email"
                                                                                        value={formData?.[dup.id]?.[field.id] || ""}
                                                                                        onChange={(e) =>
                                                                                            handleChange(section.form_section_id, field.id, e.target.value, true, dup.id)
                                                                                        }
                                                                                        className={`w-full p-2 bg-gray-200 ${isInvalid ? "p-invalid" : ""}`}
                                                                                        required={field.is_required}
                                                                                    />
                                                                                )}

                                                                                {field.input_type === "date" && (
                                                                                    <Calendar
                                                                                        value={formData?.[dup.id]?.[field.id] || ""}
                                                                                        onChange={(e) =>
                                                                                            handleChange(section.form_section_id, field.id, e.value, true, dup.id)
                                                                                        }
                                                                                        className={`w-full bg-gray-200 ${isInvalid ? "p-invalid" : ""}`}
                                                                                        required={field.is_required}
                                                                                    />
                                                                                )}

                                                                                {field.input_type === "textarea" && (
                                                                                    <InputTextarea
                                                                                        value={formData?.[dup.id]?.[field.id] || ""}
                                                                                        onChange={(e) =>
                                                                                            handleChange(section.form_section_id, field.id, e.target.value, true, dup.id)
                                                                                        }
                                                                                        rows={4}
                                                                                        className={`w-full p-2 bg-gray-200 h-auto ${isInvalid ? "p-invalid" : ""}`}
                                                                                        required={field.is_required}
                                                                                    />
                                                                                )}

                                                                                {field.input_type === "select" && field.options && (
                                                                                    <Dropdown
                                                                                        value={formData?.[dup.id]?.[field.id] || ""}
                                                                                        options={field.options.split(",").map((option) => ({
                                                                                            label: option.trim(),
                                                                                            value: option.trim(),
                                                                                        }))}
                                                                                        onChange={(e) =>
                                                                                            handleChange(section.form_section_id, field.id, e.value, true, dup.id)
                                                                                        }
                                                                                        className={`w-full bg-gray-200 ${isInvalid ? "p-invalid" : ""}`}
                                                                                        required={field.is_required}
                                                                                    />
                                                                                )}
                                                                            </div>
                                                                            );
                                                                        })}

                                                                    </div>
                                                                ))}
                                                        </div>
                                                    ))}
                                                </div>
                                            ) : null
                                        )}
                                </Card.Body>

                                <Card.Footer className="d-flex justify-content-end align-items-center px-2" data-onboarding="client-onboarding-form-actions">
                                    <Button
                                        label="Back"
                                        icon="pi pi-arrow-left"
                                        className="py-2"
                                        disabled={currentStep === 0}
                                        onClick={prevStep}
                                        severity="primary"
                                    />
                                    {currentStep === totalSteps - 1 ? (
                                        <Button
                                            label="Draft Form"
                                            icon="pi pi-check"
                                            className="py-2 ms-2"
                                            severity="success"
                                            onClick={handleSubmit} // Call handleSubmit on click
                                        />

                                    ) : (
                                        <Button
                                            label="Next"
                                            icon="pi pi-arrow-right"
                                            className="ms-2 py-2"
                                            onClick={nextStep}
                                            severity="primary"
                                            iconPos="right"
                                        />
                                    )}
                                </Card.Footer>
                            </Card>
                        ) : (
                            <Card className=" shadow-0">
                                <Card.Body>
                                    <p className="p-1 mb-0 text-center">No form selected.</p>
                                </Card.Body>
                            </Card>
                        )}
                    </Col>
                </Row>
            </Container>
            <div className={`transition-overlay ${transition}`} />
            <CustomToast ref={toastRef} />
        </>
    );
}


export default Onboarding_Form;
